import axios from 'axios';
import { initialiseCarousel } from './_helpers'
import { mediaBreakpoints } from '../utils'
import {getElement, getElements} from './../utils/functional'
import 'swiper/swiper.scss';
import { MatchHeight } from 'js-match-height';

const selectors = {
  resultDataName: '[data-result-name]',
  resultDataVata: '[data-dosha-vata-percentage]',
  resultDataPitta: '[data-dosha-pitta-percentage]',
  resultDataKapha: '[data-dosha-kapha-percentage]',
  viewButtons: '[data-view-button]'
};

export default function init ({ el, context }) {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const quizParticipantName = urlParams.get('first_name')
  const quizResultVata = urlParams.get('vata_score')
  const quizResultPitta = urlParams.get('pitta_score')
  const quizResultKapha = urlParams.get('kapha_score')

  const moduleClassName = el.dataset.moduleClassName
  const swiperContainer = el.getElementsByClassName(`${moduleClassName}_Carousel`)[0]
  const swiperPaginationClass = `${moduleClassName}_Pagination`
  const swiperPaginationElement = el.querySelector(`.${moduleClassName}_Pagination`)
  const swiperNext = el.getElementsByClassName(`${moduleClassName}_Next`)[0]
  const swiperPrevious = el.getElementsByClassName(`${moduleClassName}_Previous`)[0]
  
  const slideClass = `${moduleClassName}_Slide`

  let paginationSettings = false

  let swiperInstance

  if(swiperPaginationElement){
    paginationSettings = {
      el: swiperPaginationElement,
      type: 'bullets',
      clickable: true,
    }
  }
  
  makeCarousel();


  function makeCarousel () {
    debugger
    swiperInstance = initialiseCarousel(
      swiperContainer,
      {
        spaceBetween: 20,
        slideClass: slideClass,
        initialSlide: 0,
        slidesPerView: 1.2,
        centeredSlides: false,
        preloadImages: false,
        centerInsufficientSlides: true,
        watchSlidesProgress: true,
        breakpointsInverse: true,
        loop: false,
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrevious,
          disabledClass: 'quiz-result__insights__navigation__disabled',
        },
        breakpoints: {
          769: {
            slidesPerView: 2.3,
            spaceBetween: 30
          },
        },
        pagination: paginationSettings
      }
    )
  }

  const nodeSelectors = {
    resultDataName: document.querySelector(selectors.resultDataName),
    resultDataVata: document.querySelector(selectors.resultDataVata),
    resultDataPitta: document.querySelector(selectors.resultDataPitta),
    resultDataKapha: document.querySelector(selectors.resultDataKapha),
    viewButtons: document.querySelectorAll(selectors.viewButtons)
  };
  //debugger
  nodeSelectors.resultDataName.innerHTML = `${quizParticipantName}'s dosha`
  nodeSelectors.resultDataVata.innerHTML = `${Math.round(quizResultVata).toFixed(0)}%`
  nodeSelectors.resultDataPitta.innerHTML = `${Math.round(quizResultPitta).toFixed(0)}%`
  nodeSelectors.resultDataKapha.innerHTML = `${Math.round(quizResultKapha).toFixed(0)}%`

  setTimeout(function(){
    const matchHeight = new MatchHeight('.product-block__detail__title a', { timeout: 800 });
    const matchHeightTwo = new MatchHeight('.quiz-result__card__text');
  }, 800)
  const matchHeightThree = new MatchHeight(".quiz-result__insight__description");
  const matchHeightFour = new MatchHeight(".quiz-result__insight__title h3");

  for (var i = nodeSelectors.viewButtons.length - 1; i >= 0; i--) {
    nodeSelectors.viewButtons[i].addEventListener('click', async (e) => {
      goToOtherResult(e)
    })
  }

  const goToOtherResult = (e) => {
    e.preventDefault();
    const view = e.currentTarget.dataset.view
    const currentUrl = window.location
    const newUrl = `/pages/quiz-result?view=quiz-result-${view}&first_name=${quizParticipantName}&vata_score=${quizResultVata}&pitta_score=${quizResultPitta}&kapha_score=${quizResultKapha}`
    window.location.href = newUrl
  }
}